import { createAction } from '@reduxjs/toolkit';
import { SearchShape } from './model';

export const queryChanged = createAction<{
  text: SearchShape['text'];
  uploadData: SearchShape['uploadData'];
}>('al/search/queryChanged');

export const similarAssetChanged = createAction<{
  similarAsset: SearchShape['similarAsset'];
}>('al/search/similarAssetChanged');

export const optionsChanged = createAction<{
  options: SearchShape['options'];
  aiToggleClicked?: boolean;
}>('al/search/optionsChanged');

export const searchRequested = createAction<void, 'al/search/searchRequested'>(
  'al/search/searchRequested',
);
